module.exports = __webpack_public_path__ + "img/transfer.f4b55322.png";